import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { CARD_HELP_TEXT, CardHeadingWithHelp } from "../shared/help";

const Form16Section = ({
  canFinance,
  form16Form,
  setForm16Form,
  employees,
  handleGenerateForm16,
  form16Records,
  form16Edits,
  setForm16Edits,
  handleUpdateForm16,
  meta,
  formatPayrollCurrency,
}) => (
  <Stack spacing={6}>
    {canFinance ? (
      <Card>
        <CardHeader>
          <CardHeadingWithHelp
            title="Generate Form 16"
            helpText={CARD_HELP_TEXT.generateForm16}
          />
        </CardHeader>
        <CardBody>
          <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
            <FormControl>
              <FormLabel>Employee (optional)</FormLabel>
              <Select
                value={form16Form.userId}
                onChange={(e) =>
                  setForm16Form((prev) => ({ ...prev, userId: e.target.value }))
                }
              >
                <option value="">All eligible employees</option>
                {employees.map((employee) => (
                  <option key={employee._id} value={employee._id}>
                    {employee.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Financial Year</FormLabel>
              <Input
                value={form16Form.financialYear}
                onChange={(e) =>
                  setForm16Form((prev) => ({
                    ...prev,
                    financialYear: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>Status</FormLabel>
              <Select
                value={form16Form.status}
                onChange={(e) =>
                  setForm16Form((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="GENERATED">GENERATED</option>
                <option value="ISSUED">ISSUED</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>File Name</FormLabel>
              <Input
                value={form16Form.fileName}
                onChange={(e) =>
                  setForm16Form((prev) => ({
                    ...prev,
                    fileName: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl>
              <FormLabel>File URL</FormLabel>
              <Input
                value={form16Form.fileUrl}
                onChange={(e) =>
                  setForm16Form((prev) => ({
                    ...prev,
                    fileUrl: e.target.value,
                  }))
                }
              />
            </FormControl>
            <FormControl gridColumn={{ xl: "1 / span 3" }}>
              <FormLabel>Notes</FormLabel>
              <Input
                value={form16Form.notes}
                onChange={(e) =>
                  setForm16Form((prev) => ({ ...prev, notes: e.target.value }))
                }
              />
            </FormControl>
          </SimpleGrid>
          <Button mt={4} colorScheme="blue" onClick={handleGenerateForm16}>
            Generate Form 16
          </Button>
        </CardBody>
      </Card>
    ) : null}

    <Card>
      <CardHeader>
        <CardHeadingWithHelp
          title="Form 16 Records"
          helpText={CARD_HELP_TEXT.form16Records}
        />
      </CardHeader>
      <CardBody>
        <TableContainer>
          <Table size="sm">
            <Thead>
              <Tr>
                <Th>Employee</Th>
                <Th>FY</Th>
                <Th>Earnings</Th>
                <Th>Tax</Th>
                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {form16Records.map((record) => {
                const draft = form16Edits[record._id] || {};
                return (
                  <Tr key={record._id}>
                    <Td>{record.userId?.name || "Self"}</Td>
                    <Td>{record.financialYear}</Td>
                    <Td>{formatPayrollCurrency(record.totalEarnings, meta)}</Td>
                    <Td>{formatPayrollCurrency(record.totalTax, meta)}</Td>
                    <Td>
                      {canFinance ? (
                        <Select
                          size="xs"
                          value={draft.status || record.status}
                          onChange={(e) =>
                            setForm16Edits((prev) => ({
                              ...prev,
                              [record._id]: {
                                ...prev[record._id],
                                status: e.target.value,
                              },
                            }))
                          }
                        >
                          <option value="GENERATED">GENERATED</option>
                          <option value="ISSUED">ISSUED</option>
                        </Select>
                      ) : (
                        <Badge>{record.status}</Badge>
                      )}
                    </Td>
                    <Td>
                      {canFinance ? (
                        <Button
                          size="xs"
                          onClick={() => handleUpdateForm16(record._id)}
                        >
                          Save
                        </Button>
                      ) : null}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </CardBody>
    </Card>
  </Stack>
);

export default Form16Section;
